import { StoreConsumptionStatus } from "@gtpl/shared-models/procurement-management";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { StoreConsumption } from "./store-consumption.entity";

@Entity('store_consumption_items')
export class StoreConsumptionItems {
    @PrimaryGeneratedColumn('increment', {
        name: 'store_consumption_item_id',
    })
    storeConsumptionItemsId: number;

    @Column('int', {
        nullable: false,
        name: 'store_consumption_id',
    })
    storeConsumptionId: number;
    @Column('int', {
        nullable: true,
        name: 'item_category_id',
    })
    itemCategoryId: number;

    @Column('int', {
        nullable: false,
        name: 'item_id',
    })
    itemId: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "quantity",
        default: 0,
        unsigned:true
    })
    quantity: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "available_stock",
        default: 0,
        unsigned:true
    })
    availableStock: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "returned_quantity",
        default: 0,
        unsigned:true
    })
    returnedQuantity: number;


    @ManyToOne(type => StoreConsumption, storeConsumption => storeConsumption.storeConsumptionItems, { nullable: false, })
    @JoinColumn({ name: 'store_consumption_id' })
    storeConsumptionInfo: StoreConsumption;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    
    @Column({
        type: 'enum',
        enum: StoreConsumptionStatus,
        nullable: false,
        name: 'status',
        default:StoreConsumptionStatus.Open
    })
    status: StoreConsumptionStatus;
}